export const social = {
  email: 'silvanosilvino@hotmail.com',
  github: 'https://github.com/SilvanoGPM',
  linkedin: 'https://www.linkedin.com/in/silvano-marques-8b964a210/',
  whatsapp: 'https://api.whatsapp.com/send/?phone=5587981356579',
  resume: '/files/curriculo.pdf',
};
